export type ServerErrors =
  | 'ServerError'
  | 'SecretFetchError'
  | 'InternalFetchError';
export type ClientErrors = 'DecodeError' | 'FetchError';
export type InternalErrors = ServerErrors | ClientErrors;

export type PlexErrors =
  | 'PlexTokenError'
  | 'ArtworkNotFound'
  | 'UnexpectedMimeType'
  | InternalErrors;
export type LastFmErrors =
  | 'LastFmTokenError'
  | 'LastFmQueryError'
  | InternalErrors;
export type LastFmScrobbleErrors =
  | 'LastFmScrobblerRequestError'
  | 'LastFMScrobblerTokenError'
  | InternalErrors;
export type GoatCounterErrors = 'GoatCounterQueryError' | InternalErrors;
export type OGErrors = 'ImageGenerationFailed' | InternalErrors;

export type ErrorCodes =
  | PlexErrors
  | LastFmErrors
  | LastFmScrobbleErrors
  | GoatCounterErrors
  | OGErrors;

export interface ErrorWithCode<T extends ErrorCodes> {
  code: T;
  message: string;
  context?: {
    error?: unknown;
  } & Record<string, unknown>;
}

export const newError = <T extends ErrorCodes>(
  code: T,
  message: string,
  context?: {
    error?: unknown;
  } & Record<string, unknown>,
): ErrorWithCode<T> => ({
  code,
  message,
  context,
});
